import {
    Modal,
    ModalBody,
    Text,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Button,
    Flex,
    Img,
    Box,
    IconButton,
    useToast,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart, toggleCartModal } from "../../actions/cartActions";
import { CloseIcon } from "@chakra-ui/icons";
import { toggleCreateOrderModal } from "../../actions/orderActions";

const CartModal = () => {
    const dispatch = useDispatch();
    const cart = useSelector((state) => state.cart);
    const showCartModal = useSelector((state) => state.cart.showCartModal);
    const { cartItems } = cart;
    const toast = useToast();

    const removeFromCartHandler = (id) => {
        dispatch(removeFromCart(id));
        toast({
            title: "Producto eliminado.",
            description: "El producto ha sido eliminado del carrito.",
            status: "success",
            duration: 2000,
            isClosable: true,
        });
    };

    const updateQuantityHandler = (id, qty) => {
        dispatch(addToCart(id, qty));
    };

    const closeModal = () => {
        dispatch(toggleCartModal());
    };

    const openCreateOrderModal = () => {
        dispatch(toggleCreateOrderModal());
        closeModal();
    }

    if (!showCartModal) return null;

    return (
        <Modal isOpen={showCartModal} onClose={closeModal} size="md">
            <ModalOverlay />
            <ModalContent maxH="70vh" overflowY="auto">
                <ModalHeader>Carrito de Compras</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {cartItems.length === 0 ? (
                        <Text>Tu carrito está vacío</Text>
                    ) : (
                        cartItems.map((item) => (
                            <Flex key={item.product} my="10px" borderWidth="1px" borderRadius="lg" p="10px" position="relative">
                                <IconButton
                                    icon={<CloseIcon />}
                                    size="xs"
                                    position="absolute"
                                    top="2"
                                    right="2"
                                    onClick={() => removeFromCartHandler(item.product)}
                                />
                                <Box flex="1" mr="10px">
                                    <Img
                                        w="100%"
                                        h="100%"
                                        objectFit="contain"
                                        src={item.images[0]}
                                    />
                                </Box>
                                <Box flex="2">
                                    <Text fontSize="lg" fontWeight="bold">{item.name}</Text>
                                    <Text>Precio: ${item.price}</Text>
                                    <Flex alignItems="center" mt="10px">
                                        <Button size="sm" onClick={() => updateQuantityHandler(item.product, -1)} disabled={item.qty <= 1}>-</Button>
                                        <Text mx="10px">{item.qty}</Text>
                                        <Button size="sm" onClick={() => updateQuantityHandler(item.product, +1)} disabled={item.qty >= item.countInStock}>+</Button>
                                    </Flex>
                                </Box>
                            </Flex>
                        ))
                    )}
                    <Flex alignItems="end" justifyContent="flex-end">
                        {
                            cartItems.length > 0 && (
                                <Text fontSize="sm" fontWeight="gray.600">Total: ${cartItems.reduce((acc, item) => acc + item.qty * item.price, 0).toFixed(2)}</Text>
                            )
                        }
                    </Flex>
                    <Flex w="100%" justifyContent="flex-end" mb="10px">
                        {
                            cartItems.length > 0 && (
                                <Button colorScheme="blue" mr=".3rem" onClick={openCreateOrderModal} >Continuar</Button>
                            )
                        }
                        <Button onClick={closeModal} variant="ghost">
                            <Text color="gray.600">Cerrar</Text>
                        </Button>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default CartModal;